import { render, staticRenderFns } from "./tabList.vue?vue&type=template&id=b2d9a85e&scoped=true&"
import script from "./tabList.vue?vue&type=script&lang=js&"
export * from "./tabList.vue?vue&type=script&lang=js&"
import style0 from "./tabList.vue?vue&type=style&index=0&id=b2d9a85e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d9a85e",
  null
  
)

export default component.exports